import React from 'react';

import { Switch as MuiSwitch } from '@material-ui/core';

const Switch = props =>  <MuiSwitch {...props}/>

export default Switch;



// WEBPACK FOOTER //
// ./src/components/base/Switch/Switch.js